import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IRequest } from 'app/shared/Domains/request';
import { Configuration } from "config/config";
import { ActivatedRoute, Router } from "@angular/router";
import { SelectItem, ConfirmationService, MessageService, } from "primeng/api";
import { BreadcrumbService } from "app/breadcrumb.service";
import { AppServiceManager } from "common/services/appServiceManager";
import { IMember } from 'app/shared/Domains/member';
import { IMemberFreezeDetail } from 'app/shared/Domains/memberFreezeDetail';
import { ISettings } from "app/shared/Domains/settings";
import { IMemberEmergencyContact } from "app/shared/Domains/memberEmergencyContact";
import { Customerstrainer } from "app/shared/Domains/Customerstrainer";
import { ICompany } from "app/shared/Domains/company";
import { IAddress } from "app/shared/Domains/address";
import { IMemberContact } from "app/shared/Domains/memberContact";
import globalVariable from "../../../../globalVariable/globalVariable.json";
import { RequestStatus } from "app/shared/enums/enums";
import { IMemberFeeDetails } from 'app/shared/Domains/feeDetail';
import { AppUtils } from 'common/services/app.util';
import moment from 'moment';
import { AuthService } from 'common/services/auth.service';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { IBranch } from 'app/shared/Domains/branch';

@Component({
    selector: 'app-fee-submission-request-detail',
    templateUrl: './fee-submission-request-detail.component.html',
    styleUrls: ['./fee-submission-request-detail.component.css']
})
export class FeeSubmissionRequestDetailComponent implements OnInit {
    @Input() requestor;
    @Output("reject") reject: EventEmitter<any> = new EventEmitter();
    member: IMember;
    loading: boolean;
    freezeMemberDetails: any[];
    errorExempleNumber: any;
    company: ICompany;
    freezeDetail: IMemberFreezeDetail;
    requestId: string;
    selectedPaymentMode: any;
    paymentModes = [];
    RequestStatus = RequestStatus;
    message: string;
    numOfMonths: any;
    currentUserData: any;
    registrationFund: IMemberFeeDetails;
    feesServicesCall: any[] = [];
    onlineNoOfMembers: any;
    onlineMembers: any;
    numOfMembers: any;
    branch: IBranch;
    formattedNumber: string = '';
    durationType: string;
    noOfDays: any;
    noOfWeeks: any;

    constructor(
        private LanguageService: LanguageService,
        private route: ActivatedRoute,
        public config: Configuration,
        private confirmationService: ConfirmationService,
        private ConfirmationService: ConfirmationService,
        private router: Router,
        private messageService: MessageService,
        private breadcrumbService: BreadcrumbService,
        private appServiceManager: AppServiceManager
    ) {
        route.params.subscribe((params) => {
            this.requestId = params["id"];
            if (this.requestId !== undefined) {
                this.requestId = params["id"];
                this.getRequestById();
            }
        });
    }
    setLabel(label) {
        return this.LanguageService.GetCurrentLanguage("FeeSubmissionRequestDetailComponent", label);
    }
    ngOnInit() {
        const currentUser = localStorage.getItem('currentUser');
        this.currentUserData = JSON.parse(currentUser);
        // this.requestor = new IRequest();
        this.errorExempleNumber = globalVariable.exampledata.pakNumber;
        this.member = new IMember();
        this.company = new ICompany();
        this.freezeDetail = new IMemberFreezeDetail();
        this.member.emergencyContact = new IMemberEmergencyContact();
        this.member.emergencyContact.medicalDetail = "";
        this.member.contactDetail = new IMemberContact();
        this.member.contactDetail.contact = "";
        this.requestor.contactDetail = new IMemberContact();
        this.member.contactDetail.address = new IAddress();
        this.requestor.contactDetail.address = new IAddress();
        this.member.customerstrainer = new Customerstrainer();
        this.member.settings = new ISettings();
        this.selectedPaymentMode = '';
        this.getBranchById();

    }
    InitObjects() {
        this.requestor = new IRequest();
        this.member.settings = new ISettings();
    }

    getRequestById() {
        this.loading = true;
        this.appServiceManager
            .get("customers/requests/" + this.requestId)
            .subscribe(
                (requestor) => {
                    this.requestor = requestor;
                    this.getCustomerById();
                    console.log("Requester", this.requestor);
                },
                (error) => {
                    this.loading = false;
                }
            );
    }

    getCustomerById() {
        this.appServiceManager
            .get("customers/" + this.requestor.memberId)
            .subscribe(
                (customer) => {
                    this.member = customer;
                    this.member.oldDate = this.member.settings.dueDate;
                    this.getPackagesByID();
                    this.loading = false;
                },
                (error) => {
                    this.loading = false;
                }
            );
    }
    getPackagesByID() {
        //console.log("this.member.packageId",this.member.packageId)
        this.appServiceManager
            .get(
                "packagesBuilder/" +
                this.member.packageId
            )
            .subscribe(
                (res) => {
                    this.numOfMonths = res.noOfMonths;
                    this.numOfMembers = res.noOfMembers;
                    this.noOfDays = res.noOfDays;
                    this.noOfWeeks = res.noOfWeeks;
                    this.durationType = res.durationType;
                    console.log("No. of month(s)", this.numOfMonths);
                },
                (error: any) => {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Error Message",
                        detail: error,
                    });
                }
            );

    }

    rejectRequest() {
        this.reject.emit();
    }

    approveRequest(requestorForm) {
        let formData = requestorForm.value;
        this.ConfirmationService.confirm({
            message: "Are you sure you want to approve fee submission request?",
            accept: () => {
                this.loading = true;
                this.payFee(formData);
                // this.feeApproval();
            },
        });
    }
    getBranchById() {
        this.branch = AuthService.getLoggedInCurrentBranch();
        if(this.branch){
            if (Array.isArray(this.branch.payments)) {
            this.branch.payments.forEach(payment => {
                const existingBank = this.paymentModes.find(option => option == payment.name);
                if (!existingBank) {
                    if (payment.type == "Online") {
                        this.paymentModes.push(
                            "Online-" + payment.name
                        );
                        //this.selectedPaymentMode="Online-"+payment.name;
                    }
                    this.selectedPaymentMode = this.paymentModes[0];
                }
            });
        }
    }
        if(!this.branch){
        this.appServiceManager.get('branches/' + AuthService.getLoggedInBranch()).subscribe((res) => {
            if (res) {
                res.payments.forEach(payment => {
                    const existingBank = this.paymentModes.find(option => option == payment.name);
                    if (!existingBank) {
                        if (payment.type == "Online") {
                            this.paymentModes.push(
                                "Online-" + payment.name
                            );
                            //this.selectedPaymentMode="Online-"+payment.name;
                        }
                    }
                    this.selectedPaymentMode = this.paymentModes[0];
                });
            } else {
                this.messageService.clear();
                this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
            }
        },
            (error) => {
                this.messageService.clear();
                this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
        }
    }
    onPaymentModeChange(value: string) {
        this.selectedPaymentMode = value;
    }

    // feeApproval(){

    //         const payload = {
    //             name: this.member.name,
    //             mobile: this.member.contactDetail.contact,
    //             fee: this.member.monthFee,
    //             email: this.member.email,
    //             memberId: this.member._id,
    //             tagNumber: this.member.tagNumber,
    //             company: this.member.company,
    //             branch: this.member.branch
    //         };
    //         this.appServiceManager
    //             .post("feeApprovalMessages", payload)
    //             .subscribe(
    //                 (_res: any) => { },


    //                 (error: any) => {
    //                     });


    // }

    payFee(formData) {

        if (this.requestor.requestType == "OnlineRegistrationFee") {
            for (const memberId of this.member.paymentOnRegistration.onlineMembersIds) {
                this.appServiceManager.get("customers/" + memberId).subscribe((res: any) => {
                    if (res) {
                        let onlineMember: IMember;
                        onlineMember = res;
                        let counterCheck = 0;
                        var date = new Date(onlineMember.joiningDate);
                        let fund = new IMemberFeeDetails();
                        fund.day = new Date(onlineMember.settings.dueDate).getDate().toString();
                        fund.year = date.getFullYear();
                        fund.month = date.getMonth() + 1;
                        // this.fund.pay = totalPackageFee;
                        fund.pay = formData.pay;
                        fund.date = new Date(onlineMember.joiningDate);
                        counterCheck = counterCheck + 1;
                        const currentDate = new Date();
                        const currentMonth = currentDate.getMonth() + 1;
                        const currentYear = currentDate.getFullYear();
                        let invoiceNo = AppUtils.generateInvoiceNo(onlineMember.tagNumber, onlineMember.feeDetails, currentYear, currentMonth, false, counterCheck);
                        onlineMember.registerationFee = formData.payReg;

                        this.registrationFund = { ...fund };
                        this.registrationFund.discount = formData.registrationDiscount;
                        this.registrationFund.tax = this.requestor.feeSubmissionDetail.registrationTax;
                        if (this.numOfMembers > 1) {
                            this.registrationFund.discount = Math.round(formData.registrationDiscount / this.numOfMembers);
                            this.registrationFund.tax = Math.round(this.requestor.feeSubmissionDetail.registrationTax / this.numOfMembers);
                        }
                        //this.registrationFund.discount=formData.registrationDiscount;
                        this.registrationFund.memberId = onlineMember._id;
                        this.registrationFund.pay = parseInt(formData.payReg, 10);
                        this.registrationFund.pay = Math.round(this.registrationFund.pay / this.numOfMembers);
                        this.registrationFund.date = new Date(onlineMember.joiningDate);
                        this.registrationFund.invoice = invoiceNo;
                        this.registrationFund.feeReceiptImageUrl = this.requestor.feeSubmissionDetail.feeReceiptImageUrl;
                        this.registrationFund.transactionNumber = formData.transactionNumber;
                        this.registrationFund.paymentMode = this.selectedPaymentMode;
                        this.registrationFund.status = "Registration Fee - Paid";
                        this.registrationFund.type = 'Add Fee';
                        this.registrationFund.scope = 'Member';
                        this.registrationFund.initiatedFrom = 'signUp';
                        this.registrationFund.currentUserData = this.currentUserData;
                        this.registrationFund.createdBy = this.currentUserData.name;
                        console.log("updateFeesFund " + onlineMember.name + " - Registration Fee - Paid - per Person Registration Fee - Obj : ", this.registrationFund);
                        this.appServiceManager.post(
                            "customers/payFund",
                            this.registrationFund
                        ).subscribe((member) => {
                            console.log("success");
                        },
                            (error) => {
                                //this.loading = false;
                                this.messageService.clear();
                                this.messageService.add({
                                    severity: "info",
                                    summary: "Info Message",
                                    detail: "Something went wrong",
                                });
                            });

                        for (let ind = 0; ind <= this.numOfMonths - 1; ind++) {
                            counterCheck = counterCheck + 1;
                            let fund = new IMemberFeeDetails();
                            fund.memberId = onlineMember._id;
                            var terminDate = new Date(onlineMember.settings.dueDate);
                            var dateInLoop = new Date(onlineMember.settings.dueDate);
                            dateInLoop.setDate(1);
                            dateInLoop.setMonth(terminDate.getMonth() + ind);
                            fund.day = new Date(onlineMember.settings.dueDate).getDate().toString();
                            fund.dueDate = onlineMember.settings.dueDate;
                            fund.isDelete = onlineMember.isDelete;
                            fund.isSynced = onlineMember.isSynced;
                            fund.isDefaulter = onlineMember.isDefaulter;
                            // fund.date = this.requestor.feeSubmissionDetail.date;
                            fund.date = new Date();
                            // fund.month = this.requestor.feeSubmissionDetail.month;
                            // fund.year = this.requestor.feeSubmissionDetail.year;
                            let lastDayOfMonthInLoop: any = new Date(dateInLoop.getFullYear(), dateInLoop.getMonth() + 1, 0);
                            if (lastDayOfMonthInLoop.getDate() < terminDate.getDate()) {
                                fund.day = lastDayOfMonthInLoop.getDate();
                                fund.month = dateInLoop.getMonth() + 1;
                                fund.year = dateInLoop.getFullYear();
                            }
                            else {
                                terminDate.setMonth(terminDate.getMonth() + ind);
                                fund.day = fund.day;
                                fund.month = terminDate.getMonth() + 1;
                                fund.year = terminDate.getFullYear();
                            }
                            const currentDate = new Date();
                            const currentMonth = currentDate.getMonth() + 1;
                            const currentYear = currentDate.getFullYear();
                            fund.invoice = AppUtils.generateInvoiceNo(onlineMember.tagNumber, onlineMember.feeDetails, currentYear, currentMonth, false, counterCheck);
                            fund.status = this.requestor.feeSubmissionDetail.status;
                            fund.feeReceiptImageUrl = this.requestor.feeSubmissionDetail.feeReceiptImageUrl;

                            fund.pay = Math.round(formData.pay / this.numOfMembers);
                            if (this.numOfMonths == 1 && this.numOfMembers == 1) {
                                fund.discount = formData.monthlyDiscount;
                                fund.tax = this.requestor.feeSubmissionDetail.monthlyTax;
                            }
                            else if (this.numOfMonths > 1 && this.numOfMembers == 1) {
                                fund.discount = Math.round(formData.monthlyDiscount / this.numOfMonths);
                                fund.tax = Math.round(this.requestor.feeSubmissionDetail.monthlyTax / this.numOfMonths);
                            }
                            else if (this.numOfMonths == 1 && this.numOfMembers > 1) {
                                fund.discount = Math.round(formData.monthlyDiscount / this.numOfMembers);
                                fund.tax = Math.round(this.requestor.feeSubmissionDetail.monthlyTax / this.numOfMembers);
                            }
                            else if (this.numOfMonths > 1 && this.numOfMembers > 1) {
                                fund.discount = Math.round(formData.monthlyDiscount / this.numOfMembers);
                                fund.discount = Math.round(fund.discount / this.numOfMonths);
                                fund.tax = Math.round(this.requestor.feeSubmissionDetail.monthlyTax / this.numOfMembers);
                                fund.tax = Math.round(fund.tax / this.numOfMonths);
                            }
                            let futurePay = Math.round(formData.pay / this.numOfMembers);
                            fund.pay = Math.round(fund.pay / this.numOfMonths);
                            let percentagePaid = futurePay / parseInt(onlineMember.monthFee) * 100;
                            let numberOfDays: any = '';
                            if (this.numOfMonths < 2) {
                                if (futurePay != parseInt(onlineMember.monthFee)) {
                                    numberOfDays = (percentagePaid / 100) * 30;
                                } else {
                                    numberOfDays = moment(onlineMember.settings.dueDate); // Assuming a month is 30 days for other cases.
                                    numberOfDays = numberOfDays.daysInMonth();
                                    console.log("numberOfDays", numberOfDays)
                                }
                                numberOfDays = Math.floor(numberOfDays);
                            }
                            else {
                                let months = [];
                                months[0] = moment(onlineMember.settings.dueDate);
                                months[0] = months[0].daysInMonth();
                                let futureDate = moment(onlineMember.settings.dueDate)
                                for (let i = 0; i < this.numOfMonths - 1; i++) {
                                    futureDate = moment(futureDate).add(months[i], 'days');
                                    months[i + 1] = futureDate.daysInMonth();
                                    console.log("monthss:", months[i + 1]);
                                    numberOfDays += Math.floor(months[i]);
                                    numberOfDays = Math.floor(numberOfDays);
                                }
                                numberOfDays += Math.floor(months[this.numOfMonths - 1]);
                                numberOfDays = Math.floor(numberOfDays);
                            }
                            let futureDate = moment(onlineMember.settings.dueDate).add(numberOfDays, 'days').toISOString();
                            fund.dueDate = new Date(futureDate);

                            fund.transactionNumber = formData.transactionNumber;
                            fund.paymentMode = this.selectedPaymentMode;
                            fund.type = 'Add Fee';
                            fund.scope = 'Member';
                            fund.initiatedFrom = 'fee submission';
                            fund.currentUserData = this.currentUserData;
                            fund.createdBy = this.currentUserData.name;
                            this.appServiceManager.post("customers/payFund", fund)
                                .subscribe(
                                    (member) => {
                                        if (ind == 1- 1) {
                                            this.updateRequestStatus();
                                        }
                                    },
                                    (error) => {
                                        this.loading = false;
                                        this.messageService.clear();
                                        this.messageService.add({
                                            severity: "info",
                                            summary: "Info Message",
                                            detail: "Something went wrong",
                                        });
                                    }
                                );
                        }

                    } else {
                        this.messageService.clear();
                        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
                    }
                },
                    (error) => {
                        this.messageService.clear();
                        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
                    });
            }
        }
        else {
            let counterCheck = 0
            for(let i = 0; i < this.numOfMembers; i++){
            for (let ind = 0; ind <= 1 - 1; ind++) {
                counterCheck = counterCheck + 1;
                let fund = new IMemberFeeDetails();
                if(i==0){
                fund.memberId = this.member._id;
                }else{
                fund.memberId = this.member.relatedMember[i-1].memberId;
                }
                var terminDate = new Date(this.member.settings.dueDate);
                var dateInLoop = new Date(this.member.settings.dueDate);
                dateInLoop.setDate(1);
                dateInLoop.setMonth(terminDate.getMonth() + ind);
                fund.day = new Date(this.member.settings.dueDate).getDate().toString();
                fund.dueDate = this.member.settings.dueDate;
                fund.isDelete = this.member.isDelete;
                fund.isSynced = this.member.isSynced;
                fund.isDefaulter = this.member.isDefaulter;
                // fund.date = this.requestor.feeSubmissionDetail.date;
                fund.date = new Date();
                // fund.month = this.requestor.feeSubmissionDetail.month;
                // fund.year = this.requestor.feeSubmissionDetail.year;
                let lastDayOfMonthInLoop: any = new Date(dateInLoop.getFullYear(), dateInLoop.getMonth() + 1, 0);
                if (lastDayOfMonthInLoop.getDate() < terminDate.getDate()) {
                    fund.day = lastDayOfMonthInLoop.getDate();
                    fund.month = dateInLoop.getMonth() + 1;
                    fund.year = dateInLoop.getFullYear();
                }
                else {
                    terminDate.setMonth(terminDate.getMonth() + ind);
                    fund.day = fund.day;
                    fund.month = terminDate.getMonth() + 1;
                    fund.year = terminDate.getFullYear();
                }
                const currentDate = new Date();
                const currentMonth = currentDate.getMonth() + 1;
                const currentYear = currentDate.getFullYear();
                fund.invoice = AppUtils.generateInvoiceNo(this.member.tagNumber, this.member.feeDetails, currentYear, currentMonth, false, counterCheck);
                fund.status = this.requestor.feeSubmissionDetail.status;
                fund.feeReceiptImageUrl = this.requestor.feeSubmissionDetail.feeReceiptImageUrl;
                if(this.numOfMembers > 1){
                fund.pay = Math.round(formData.pay/this.numOfMembers);
                }else{
                fund.pay = Math.round(formData.pay);
                }
                fund.discount = 0;
                if (this.numOfMonths == 1 && this.numOfMembers == 1) {
                    fund.tax = this.requestor.feeSubmissionDetail.monthlyTax;
                }
                else if (this.numOfMonths > 1 && this.numOfMembers == 1) {
                    fund.tax = Math.round(this.requestor.feeSubmissionDetail.monthlyTax);
                }
                else if (this.numOfMonths == 1 && this.numOfMembers > 1) {
                    fund.tax = Math.round(this.requestor.feeSubmissionDetail.monthlyTax/ this.numOfMembers);
                }
                else if (this.numOfMonths > 1 && this.numOfMembers > 1) {
                    fund.tax = Math.round(this.requestor.feeSubmissionDetail.monthlyTax / this.numOfMembers);
                    fund.tax = Math.round(fund.tax );
                }
                // if(this.numOfMonths==1 && this.numOfMembers==1){
                //     fund.discount=formData.monthlyDiscount;
                // }
                // else if(this.numOfMonths!=1 && this.numOfMembers==1){
                //     fund.discount=formData.monthlyDiscount /this.numOfMonths;
                // }
                // else if(this.numOfMonths==1 && this.numOfMembers!=1){
                //     fund.discount=formData.monthlyDiscount/this.numOfMembers;
                // }
                let futurePay = formData.pay/this.numOfMembers;
                fund.pay = Math.round(fund.pay);
                let percentagePaid = futurePay / parseInt(this.member.monthFee) * 100;
                let numberOfDays: any = '';
                if(this.durationType == 'months'){
                    if (this.numOfMonths < 2) {
                        if (futurePay != parseInt(this.member.monthFee)) {
                            numberOfDays = (percentagePaid / 100) * 30;
                        } else {
                            numberOfDays = moment(this.member.settings.dueDate); // Assuming a month is 30 days for other cases.
                            numberOfDays = numberOfDays.daysInMonth();
                            console.log("numberOfDays", numberOfDays)
                        }
                        numberOfDays = Math.floor(numberOfDays);
                    }
                    else {
                        let months = [];
                        months[0] = moment(this.member.settings.dueDate);
                        months[0] = months[0].daysInMonth();
                        let futureDate = moment(this.member.settings.dueDate)
                        for (let i = 0; i < this.numOfMonths - 1; i++) {
                            futureDate = moment(futureDate).add(months[i], 'days');
                            months[i + 1] = futureDate.daysInMonth();
                            console.log("monthss:", months[i + 1]);
                            numberOfDays += Math.floor(months[i]);
                            numberOfDays = Math.floor(numberOfDays);
                        }
                        numberOfDays += Math.floor(months[this.numOfMonths - 1]);
                        numberOfDays = Math.floor(numberOfDays);
                    }
                }
                else if(this.durationType == 'days'){
                    numberOfDays = this.noOfDays;
                }
                else if(this.durationType == 'weeks'){
                    numberOfDays = this.noOfWeeks * 7 ;
                }
                let futureDate = moment(this.member.settings.dueDate).add(numberOfDays, 'days').toISOString();
                fund.dueDate = new Date(futureDate);
                fund.transactionNumber = formData.transactionNumber;
                fund.paymentMode = this.selectedPaymentMode;
                fund.type = 'Add Fee';
                fund.scope = 'Member';
                fund.initiatedFrom = 'fee submission';
                fund.currentUserData = this.currentUserData;
                fund.createdBy = this.currentUserData.name;
                fund.isApproved = true;
                this.appServiceManager.post("customerFees/payReqFund", fund)
                    .subscribe(
                        (member) => {
                            if (ind == 1 - 1) {
                                this.updateRequestStatus();
                            }
                        },
                        (error) => {
                            this.loading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: "info",
                                summary: "Info Message",
                                detail: "Something went wrong",
                            });
                        }
                    );
            }
         }
        }
        //console.log(onlineMember);

    }

    updateRequestStatus() {
        this.appServiceManager
            .post(`requests/${this.requestor._id}/approve/registration`, this.member)
            .subscribe(
                (member) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "success",
                        summary: "Success Message",
                        detail: "Fee submission request has been approved successfully.",
                    });
                    setTimeout(() => {
                        this.router.navigateByUrl(`/members/member/${this.requestor.memberId};fee=true`);
                    }, 300);
                },
                (error) => {
                    this.loading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "info",
                        summary: "Info Message",
                        detail: "Something went wrong",
                    });
                }
            );
    }
}
